import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.ActionsBlock', {
    removeRequestTitle: 'Remove the request',
    saveDraftTitle: 'Save the changes',
    saveAndSubmitTitle: 'Submit the request for approval. The Approvers will be notified.',
    saveAndSubmitText: 'Submit for approval',
    saveAndResubmitText: 'Resubmit for approval',
    saveAndTakeActionTitle: 'Update the request. The Approvers will be notified.',
    saveAndResubmitTitle: 'Submit the request for approval. The Approvers will be notified.',
    saveAndApproveTitle: 'Save the changes and approve.',
    saveAndApproveText: 'Save and approve',
    deleteConfirmationText: 'Are you sure?',
    importFileTitle: 'Import file',
    submitButton: 'submit',
    resubmitButton: 'resubmit',
    saveChanges: 'Save changes',
    saveChangesAndSubmitForApproval: 'Save changes and submit for approval',
});
